<template>
  <v-list>
    <v-list-item v-if="feed.icon">
      <v-list-item-avatar size="80">
        <v-img v-bind:src="feed.icon" />
      </v-list-item-avatar>
    </v-list-item>

    <v-list-item link @click="$emit('click')">
      <v-list-item-content>
        <v-list-item-title class="title">
          {{ feed.title }}
        </v-list-item-title>
        <v-list-item-subtitle>{{ feed.feedUrl }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: ["feed"],
};
</script>